/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {DelEmployeeTimeWindowAssignmentVoModel} from "./del-employee-time-window-assignment-vo.model";

export class DelEmployeeAssignmentVoModel extends JSONable {
  uuid: string | undefined = undefined;
  pid: string | undefined = undefined;
  name: string | undefined = undefined;
  mainSales: boolean | undefined = undefined;
  active: boolean | undefined = undefined;
  salesUuid: string | undefined = undefined;
  employeeTimeWindowAssignmentVOList: DelEmployeeTimeWindowAssignmentVoModel[] | undefined = undefined;
}
